import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { useGeo } from '@features/geo/use-geo'
import Fonts from '@themes/Fonts'
import Metrics from '@themes/Metrics'

type Props = {
  firstName?: string | null
}

export default function Salutation(props: Props) {
  const { firstName } = props

  const geo = useGeo()
  const timeOfDay = useTimeOfDay(geo?.latitude)

  const greeting = `Good ${timeOfDay}`

  return (
    <View style={styles.container}>
      <Text style={styles.greeting}>
        {firstName ? `${greeting}, ${firstName}!` : `${greeting}!`}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: Metrics.paddingHorizontal,
  },
  greeting: {
    fontSize: Fonts.size.h5,
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
  },
})

function useTimeOfDay(latitude: number = 38.0) {
  /** @source https://stackoverflow.com/a/36817521 */
  const daylightHours = React.useMemo(() => {
    const today = new Date()
    const dayOfYear = Math.floor(
      (today.getTime() - new Date(today.getFullYear(), 0, 1).getTime()) /
        (1000 * 60 * 60 * 24)
    )

    const P = Math.asin(
      0.39795 *
        Math.cos(
          0.2163108 +
            2 * Math.atan(0.9671396 * Math.tan(0.0086 * (dayOfYear - 186)))
        )
    )

    const daylightHour =
      24 -
      (24 / Math.PI) *
        Math.acos(
          Math.sin(
            (0.8333 * Math.PI) / 180 +
              Math.sin((latitude * Math.PI) / 180) * Math.sin(P)
          ) /
            (Math.cos((latitude * Math.PI) / 180) * Math.cos(P))
        )
    return daylightHour
  }, [latitude])

  const nightHours = 24 - daylightHours
  const sunrise = 0 + nightHours / 2
  const sunset = sunrise + daylightHours

  // hours elapsed since midnight, as a decimal
  const currentHour = new Date().getHours()

  if (currentHour >= 12 && currentHour <= sunset) return 'afternoon'
  if (currentHour > sunset) return 'evening'

  return 'morning'
}
